/* eslint-disable */
import qs from 'qs';
import { actions } from 'forms/rrf';
import { toast } from 'react-toastify';
import irelandApi from '../irelandApi';
import store, { history } from '../store';
import ToastMessage from '../components/common/toast-message';
import { clear } from '../utils/tokenUtils';
import { mapKeys, snakeCase } from 'lodash';

const prepareUserPayload = (payload) => {
  const userData = { ...payload };

  if (userData.abm_relief) {
    const abmReliefUserId = userData.abm_relief['abm_relief_user_id'];

    userData.abm_relief_attributes = {
      id: userData.abm_relief['id'] ? userData.abm_relief['id'] : null,
      abm_relief_user_id: abmReliefUserId,
      start_date: userData.abm_relief['start_date'],
      end_date: userData.abm_relief['end_date']
    };

    if (abmReliefUserId === '') {
      userData.abm_relief_attributes._destroy = true;
    }

    if (userData.abm_relief_attributes.start_date === '') {
      delete userData.abm_relief_attributes.start_date;
    }

    if (userData.abm_relief_attributes.end_date === '') {
      delete userData.abm_relief_attributes.end_date;
    }

    delete userData.abm_relief;
  
    if (userData.abm_relief_attributes.id === null && userData.abm_relief_attributes.abm_relief_user_id === undefined) {
      delete userData.abm_relief_attributes;
    }
  }

  return userData
};

const assembleUserDetails = (payLoad) => {
  const mPayLoad = {...payLoad};
  mPayLoad.staff_permission_ids = [];
  Object.keys(payLoad.staff_permission_ids).forEach((key) => {
    if (payLoad.staff_permission_ids[key].checked === 'true') {
      mPayLoad.staff_permission_ids.push(key);
    }
  });
  return mPayLoad;
};

export const getUsers = (query, userGroup, status, page) => (dispatch) => {
  dispatch({type: 'GET_USER_LIST_PENDING'});
  const q = {text: query, user_group_id: userGroup, status};
  return irelandApi.get(`/api/admin/manage_users?${qs.stringify({q}, {encodeValuesOnly: true})}&page=${page}`)
    .then((response) => {
      dispatch({type: 'GET_USER_LIST_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_USER_LIST_REJECTED', payLoad: error.data});
    });
};

export const getUserDetails = id => (dispatch) => {
  dispatch({type: 'GET_USER_PENDING'});
  const link = `/api/admin/manage_owners/${id}`;
  return irelandApi.get(link)
    .then((response) => {
      const {attributes} = response.data.data;
      const permissions = response.data.data.relationships['staff-permissions'];
      const permission_ids = {};
      if (permissions) {
        permissions.data.forEach((item) => {
          permission_ids[item.id] = {
            name: item.name,
            checked: `${item.checked}`
          };
        });
      }

      const user = {
        title: attributes.title,
        first_name: attributes['first-name'],
        last_name: attributes['last-name'],
        date_of_birth: attributes['date-of-birth'],
        personal_address_1: attributes['personal-address-1'] || '',
        personal_address_2: attributes['personal-address-2'] || '',
        personal_address_3: attributes['personal-address-3'] || '',
        personal_address_4: attributes['personal-address-4'] || '',
        personal_eircode: attributes['personal-eircode'] || '',
        comms_email: attributes['comms-email'] || false,
        comms_mobile: attributes['comms-mobile'] || false,
        email: attributes.email || '',
        mobile: attributes.mobile || '',
        status: attributes.status,
        account_locked: `${attributes['account-locked']}`,
        thirty_day_exception: `${attributes['thirty-day-exception']}`,
        staff_permission_ids: permission_ids
      };

      dispatch(actions.load('deep.admin_user.details', user));
      dispatch({type: 'GET_USER_FULFILLED', payLoad: response.data, saveLink: link});
    })
    .catch((error) => {
      if(error.hasOwnProperty('data')) {
        dispatch({
          type: 'GET_USER_REJECTED',
          payLoad: error.data
        });
      } else {
        console.error(error);
      }
    });
};

export const getUserEdit = id => (dispatch) => {
  dispatch({type: 'GET_USER_PENDING'});
  const link = `/api/admin/manage_admins/${id}`;
  return irelandApi.get(link)
    .then((response) => {
      const attributes = response.data.data.attributes;
      const user = {
        title: attributes.title,
        first_name: attributes['first-name'],
        last_name: attributes['last-name'],
        comms_email: attributes['comms-email'] || 'true',
        email: attributes.email || '',
        status: `${attributes.status}`,
        account_locked: `${attributes['account-locked']}`,
        user_group_id: `${attributes['user-group-id']}`,
        rdr_code: attributes['rdr-code'],
        employee_code: attributes['employee-code'],
        ror_code: attributes['ror-code'],
        abm_code: attributes['abm-code'],
        am_code: attributes['am-code'],
        ffde_code: attributes['ffde-code'],
        rbm_code: attributes['rbm-code'],
        date_of_birth: attributes['date-of-birth'],
        abm_relief: {
          abm_relief_user_id: attributes['abm-relief']['abm-relief-user-id'],
          start_date: attributes['abm-relief']['start-date'],
          end_date: attributes['abm-relief']['end-date'],
          id: attributes['abm-relief']['id']
        }
      };

      dispatch(actions.load('deep.admin_user.edit', user));
      dispatch({type: 'GET_USER_FULFILLED', payLoad: response.data, saveLink: link});
    })
    .catch((error) => {
      if(error.hasOwnProperty('data')) {
        dispatch({
          type: 'GET_USER_REJECTED',
          payLoad: error.data
        });
      } else {
        console.error(error);
      }
    });
};

export const getUserBaseData = () => (dispatch) => {
  dispatch({type: 'INITIALIZE_ADD_USER_PENDING'});
  return irelandApi.get('/api/admin/manage_admins/new')
    .then((response) => {
      const meta = response.data.meta;
      dispatch({type: 'INITIALIZE_ADD_USER_FULFILLED', payLoad: meta});
    })
    .catch((error) => {
      dispatch({type: 'INITIALIZE_ADD_USER_REJECTED', payLoad: error.data});
    });
};

export const saveUser = payLoad => irelandApi.post('/api/admin/manage_owners/', {user: assembleUserDetails(payLoad)})
  .then((response) => {
    toast.success(<ToastMessage iconStyle="success" message="User has been saved successfully"/>);
    store.dispatch({type: 'USER_SAVE_SUCCESSFUL'});
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during save user"/>);
    store.dispatch(actions.resetValidity('deep.admin_user.details'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const saveAdmin = payLoad => irelandApi.post('/api/admin/manage_admins/', {user: payLoad})
  .then((response) => {
    toast.success(<ToastMessage iconStyle="success" message="User has been saved successfully"/>);
    store.dispatch({type: 'ADMIN_SAVE_SUCCESSFUL', payLoad: response.data});
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during save user"/>);
    store.dispatch(actions.resetValidity('deep.admin_user.edit'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const updateUser = (link, payLoad) => irelandApi.patch(link, {user: assembleUserDetails(payLoad)})
  .then((response) => {
    toast.success(<ToastMessage iconStyle="success" message="User has been saved successfully"/>);
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during save user"/>);
    store.dispatch(actions.resetValidity('deep.admin_user.details'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const updateAdmin = (id, payLoad) => irelandApi.patch(`/api/admin/manage_admins/${id}`, { user: prepareUserPayload(payLoad) })
  .then((response) => {
    toast.success(<ToastMessage iconStyle="success" message="User has been saved successfully"/>);
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during save user"/>);
    store.dispatch(actions.resetValidity('deep.admin_user.edit'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const sendWelcomeEmail = id => dispatch => irelandApi.post(`/api/admin/manage_admins/${id}/generate_welcome_email`)
  .then((response) => {
    toast.success(<ToastMessage iconStyle="success" message="Welcome email sent successfully"/>);
    dispatch({type: 'WELCOME_EMAIL_SENT'});
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="Unable to send welcome email"/>);
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const updatePermissions = (id, payLoad) => irelandApi.patch(`/api/admin/manage_owners/${id}/permissions`, {user: assembleUserDetails({staff_permission_ids: payLoad})})
  .then((response) => {
    toast.success(<ToastMessage iconStyle="success" message="User permissions has been saved successfully"/>);
    store.dispatch(actions.reset('deep.admin_user.edit'));
    store.dispatch(actions.reset('deep.admin_user.details'));
    history.push('/admin/users');
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during save user permissions"/>);
    store.dispatch(actions.resetValidity('deep.admin_user.edit'));
    store.dispatch(actions.resetValidity('deep.admin_user.details'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const removePendingOutlet = (userId, pendingOutletId) =>
  irelandApi.delete(`/api/admin/manage_owners/${userId}/pending_outlets/${pendingOutletId}`).then(() => {
    toast.success(<ToastMessage iconStyle="success" message="Pending outlet removed"/>);
    store.dispatch({ type: 'PENDING_OUTLET_REMOVED', payLoad: { id: pendingOutletId } });
  }).catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred whilst removing the outlet"/>);

    return Promise.reject(error);
  });

export const linkPendingOutlet = (pendingOutletId, outletId) =>
  irelandApi.post(
    `/api/admin/pending_outlets/${pendingOutletId}/link`,
    { outlet_id: outletId }
  ).then(({ data }) => {
    toast.success(<ToastMessage iconStyle="success" message="Outlet linked to user"/>);
    // Transform JSON-API top-level structure into structure used by relationships
    const { id, type, attributes } = data.data;
    const outlet = mapKeys({ id, ...attributes }, (_, key) => snakeCase(key));

    store.dispatch({ type: 'PENDING_OUTLET_LINKED', payLoad: { pendingOutletId, outlet }});
  }).catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred whilst linking the outlet"/>);

    return Promise.reject(error);
  });

export const deleteUser = id => (dispatch) => {
  dispatch({type: 'DELETE_USER_PENDING'});
  return irelandApi.delete(`/api/admin/manage_owners/${id}`)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="User has been deleted successfully"/>);
      dispatch({type: 'DELETE_USER_FULFILLED', payLoad: response.data, id});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during delete user"/>);
      dispatch({type: 'DELETE_USER_REJECTED', payLoad: error.data});
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    });
};

export const deleteAdmin = id => (dispatch) => {
  dispatch({type: 'DELETE_ADMIN_PENDING'});
  return irelandApi.delete(`/api/admin/manage_admins/${id}`)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="User has been deleted successfully"/>);
      dispatch({type: 'DELETE_ADMIN_FULFILLED', payLoad: response.data, id});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during delete user"/>);
      dispatch({type: 'DELETE_ADMIN_REJECTED', payLoad: error.data});
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    });
};

const startImpersonation = ({ url, loginPath, id }) =>
  irelandApi.post(url, { user_id: id })
    .then((response) => {
      sessionStorage.setItem('pending-impersonation', response.data.name || '');
      clear();
      window.location.href = loginPath;
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Unable to start pseudo login"/>);
      return null;
    });

export const doPseudoLogin = id => startImpersonation({
  url: '/api/admin/users/impersonation_requests', loginPath: '/admin/login', id
});

export const doPseudoLoginRep = id => startImpersonation({
  url: '/api/team/users/impersonation_requests', loginPath: '/team/login', id
});

export const resetPrivacyPolicyForAllUsers = () => dispatch => irelandApi.patch('api/admin/users/reset_privacy_policy')
.then((response) => {
  toast.success(<ToastMessage iconStyle="success" message="All user's privacy policy consent has been reset."/>);
})
.catch((error) => {
  toast.error(<ToastMessage iconStyle="error" message="Failed to reset privacy policy consents."/>);
  return Promise.reject();
});
